import { MAX_TASK_IMAGE_MB, MAX_TASK_IMAGES, MAX_TASK_IMAGES_MESSAGE, MAX_TASK_VIDEO_MB, MAX_TASK_VIDEOS, MAX_TASK_VIDEOS_MESSAGE } from '../constants';

const VIDEO_EXT_RE = /\.(mp4|webm|mov|m4v|ogv)$/i;
const IMAGE_EXT_RE = /\.(jpe?g|png|gif|webp|bmp)$/i;

export const VIDEO_MIMES = new Set([
    'video/mp4',
    'video/webm',
    'video/quicktime',
    'video/x-m4v',
    'video/ogg',
]);

export const IMAGE_MIMES = new Set([
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/webp',
    'image/gif',
    'image/bmp',
]);

export const isVideoPath = (path?: string | null): boolean => {
    if (!path) {
        return false;
    }
    const clean = path.split('?')[0].split('#')[0];
    return VIDEO_EXT_RE.test(clean);
};

export const isImagePath = (path?: string | null): boolean => {
    if (!path) {
        return false;
    }
    const clean = path.split('?')[0].split('#')[0];
    return IMAGE_EXT_RE.test(clean);
};

export const isVideoFile = (file: Pick<File, 'type' | 'name'>): boolean => {
    const mime = (file.type || '').toLowerCase();
    if (VIDEO_MIMES.has(mime)) {
        return true;
    }
    return VIDEO_EXT_RE.test(file.name || '');
};

export const isImageFile = (file: Pick<File, 'type' | 'name'>): boolean => {
    const mime = (file.type || '').toLowerCase();
    if (IMAGE_MIMES.has(mime) || mime.startsWith('image/')) {
        return true;
    }
    return IMAGE_EXT_RE.test(file.name || '');
};

export const splitTaskMedia = <T extends { imagePath: string }>(files: T[] | null | undefined) => {
    const list = files || [];
    return {
        videos: list.filter((item) => isVideoPath(item.imagePath)),
        images: list.filter((item) => !isVideoPath(item.imagePath)),
    };
};

export const stripMediaBySrc = (html: string, src: string): string => {
    if (!html || !src) {
        return html;
    }
    const escaped = src.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return html
        .replace(new RegExp(`<img[^>]*src=["']${escaped}["'][^>]*>`, 'gi'), '')
        .replace(new RegExp(`<video[^>]*src=["']${escaped}["'][^>]*>[\\s\\S]*?</video>`, 'gi'), '')
        .replace(new RegExp(`<video[^>]*src=["']${escaped}["'][^>]*/>`, 'gi'), '');
};

export const MEDIA_ACCEPT = 'image/*,video/mp4,video/webm,video/quicktime,.mp4,.webm,.mov,.m4v';

export const validateTaskMediaFile = (
    file: File,
    counts: { imageCount: number; videoCount: number },
): string | null => {
    if (isVideoFile(file)) {
        if (counts.videoCount >= MAX_TASK_VIDEOS) {
            return MAX_TASK_VIDEOS_MESSAGE;
        }
        if (file.size > MAX_TASK_VIDEO_MB * 1024 * 1024) {
            return `Размер видео не должен превышать ${MAX_TASK_VIDEO_MB}MB`;
        }
        return null;
    }
    if (isImageFile(file)) {
        if (counts.imageCount >= MAX_TASK_IMAGES) {
            return MAX_TASK_IMAGES_MESSAGE;
        }
        if (file.size > MAX_TASK_IMAGE_MB * 1024 * 1024) {
            return `Размер изображения не должен превышать ${MAX_TASK_IMAGE_MB}MB`;
        }
        return null;
    }
    return 'Можно загружать изображения (JPG, PNG, WEBP, GIF, BMP) или видео (MP4, WEBM, MOV)';
};
